export default "__VITE_ASSET__FPBNdixt__"